import React from 'react'
import { useQuery } from '@apollo/client';
import {GET_GENDERS} from "../../../queries/genders";
import {useTranslation} from "react-i18next";


const GenderSelect = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(GET_GENDERS);

  if (loading) return  <p>Loading</p>;
  if (error) return <p>ERROR</p>;
  if (!data) return <p>Not found</p>;

  let optionsItems = (data.Genders || []).map((gender) => {
    return (<option key={gender.value} value={gender.value}>{t(gender.description)}</option>)
  })

  return (
    <select ref={ref} {...props} className="block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
      { optionsItems }
    </select>
  )
})

export default GenderSelect
